let lStorageAvailable = false; //TODO: Define this variable
var estimatorGrid = {
  step:1,
  valuesDefault:{
    tileDimension:'',
    totalArea: 0,
    iArea: '',
    iLength: '',
    iWidth: '',
    type:'area',
  },values:{},
  results:{ },
  
  
  generalActions() {
    $('.estimator-back').on('click', function () {
      if(estimatorGrid.step > 1){
        estimatorGrid.step --;
        $('.estimator-steps').hide();
        $('.step'+estimatorGrid.step+'-estimator').show();
        $('.continue-button').addClass('tw-block');
      }
      if(estimatorGrid.step == 1){
        $('.estimator-back').css('opacity',0);
      }
    });
    $('#btn-grid-estimator-step-3').on('click', function () {
      estimatorGrid.save();
    });
    $('.clear-selections-cta').on('click', function () {
        estimatorGrid.clear();
        estimatorGrid.init();
    });   
  },
  step1Actions: function(){
    let self = this;
    $('.option1-step1').on('click', function () {
      if($(this).hasClass('selected-option')) {
      } else {
        if($('.option2-step1').hasClass('selected-option')){
          $('.option2-step1').removeClass('selected-option');
          $('.option2-step1').find('.form-estimator-selected').hide();
        }
            
        $(this).addClass('selected-option');
        $(this).find('.form-estimator-selected').show();
        estimatorGrid.values.tileDimension = '24" x 24"';
        estimatorGrid.nextStep(1);
      }
      
    });
    $('.option2-step1').on('click', function () {
        if($(this).hasClass('selected-option')){
        } else {
          if($('.option1-step1').hasClass('selected-option')){
            $('.option1-step1').removeClass('selected-option');
            $('.option1-step1').find('.form-estimator-selected').hide();
          }
          
          $(this).addClass('selected-option');
          $(this).find('.form-estimator-selected').show();
          estimatorGrid.values.tileDimension = '48" x 24"'
          estimatorGrid.nextStep(1);
        }
    })
  },
  step2ACtions: function(){
    let self = this;
    self.step1ValidateButton();
    if($('input[name=estimation-type]').length>0){
      $('input[name=estimation-type]').change(function(){
        self.values.type=$(this).val();
        if(self.values.type=='area'){
          $('.estimation-input-width').val('');
          $('.estimation-input-length').val('');
        }else{
          $('.estimation-input-area').val('');
        }
        $('.estimator-grid-type').hide();
        $('#estimator-grid-type-'+self.values.type).show();
        self.step2ValidateButton();
      });
    }
    function onAreaChange(){
      self.step2ValidateButton();
    }
    $('.input-gird-estimator').change(function(){
      self.step2ValidateButton();
    });
    $('.input-gird-estimator').keyup(function() {
      self.step2ValidateButton();
    });
    $('#step2-estimator-grid').submit(function(event){
      event.preventDefault();
      let hasError = false;
      const inputArea = $("#estimation-type-area");
      if(inputArea.is(":checked")) {
        $('.estimation-input-area').each(function() {
          const numberValue = Number($(this).val().replace(/\D/g, ""))
          if(numberValue > 0){
            $(this).closest(".has-error").removeClass("has-error");
            hasError = false;
          }else{
            hasError = true;
            $(this).closest('.estimation-input-list-item').addClass("has-error");
          }
        });
      }else {
        $('.estimation-input-width').each(function(){
          let heightElem = $(this).siblings();
          const numberValueWidth = Number($(this).val().replace(/\D/g, ""))
          const numberValueHeight = Number(heightElem.val().replace(/\D/g, ""))
          if(numberValueWidth > 0 && numberValueHeight >0){
            $(this).closest(".has-error").removeClass("has-error");
            hasError = false;
          }else{
            hasError = true;
            $(this).closest('.estimation-input-list-item').addClass("has-error");
          }
        });
      }
      if(hasError){
        return !hasError;
      }
      self.calculateMaterials();
      
      $('#mainBean-value').html(self.results.mainBeamCartons);
      $('#24-crossTee-value').html(self.results.crossTee2ftCartons);
      $('#48-crossTee-value').html(self.results.crossTee4ftCartons);
      $('#wallMolding-value').html(self.results.moldingCartons);
      $('#gaugeHanger-value').html(self.results.hangerWireCartons);
      $('#area-calc-txt').html(self.values.totalArea.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
      $('#tile-dimension-txt').html(self.values.tileDimension);

      estimatorGrid.nextStep(2);
    })
  },
  step1ValidateButton: function () {
    let self = this;
    let btnContinue = $('.continue-button');
    
    if ($('.option1-step1').hasClass('selected-option') || $('.option2-step1').hasClass('selected-option')) {
      btnContinue.addClass('tw-block');
    }
    btnContinue.on('click', function () {estimatorGrid.nextStep(1);});
  },
  step2ValidateButton: function(){
    let self = this;
    let btnSubmit = $('#btn-grid-estimator-step-2');
    let tAreaEntered = 0;
    $('.estimation-input-area').each(function(){
      const numberValue = Number($(this).val().replace(/\D/g, ""))
      tAreaEntered+=numberValue
      $(this).val(numberValue > 0 ? numberValue.toLocaleString("en-US") : '')
    });
    self.values.iArea = tAreaEntered;
    let tAreaEnteredWL = 0;
    $('.estimation-input-width').each(function(){
      let heightElem = $(this).siblings();
      const numberValueWidth = Number($(this).val().replace(/\D/g, ""))
      const numberValueHeight = Number(heightElem.val().replace(/\D/g, ""))
      tAreaEnteredWL+= (numberValueWidth) * (numberValueHeight)
      $(this).val(numberValueWidth > 0 ? numberValueWidth.toLocaleString("en-US") : '')
      heightElem.val(numberValueHeight > 0 ? numberValueHeight.toLocaleString("en-US") : '')
    });
    self.values.iWidth = $('.estimation-input-width').val();
    self.values.iLength = $('.estimation-input-length').val();
    if(this.values.type=='area'){
      self.values.totalArea = self.values.iArea;
      if(self.values.iArea >0){
        btnSubmit.prop('disabled', false);
      }else{
        btnSubmit.prop('disabled', true);
      }
    }else{
      self.values.totalArea = parseFloat(tAreaEnteredWL).toFixed(2);
      if(tAreaEnteredWL >0 ){
        btnSubmit.prop('disabled', false);
      }else{
        btnSubmit.prop('disabled', true);
      }
    }

    // Additional material to cover any breaks or waste
    var AREA_BUFFER_RATIO = 1.02;
    self.values.totalArea = self.values.totalArea * AREA_BUFFER_RATIO;
    // self.values.totalArea = roundOffTo(self.values.totalArea);// round to next 100
  },
  calculateMaterials: function() {
    let area = this.values.totalArea;
    let tile_dimension = this.values.tileDimension;
    let resultsObject = {};
    //default values for sqft
    let sqft_Mb = 240;
    let sqft_Ct4 = 240;
    let sqft_Ct2 = 120;
    let sqft_Mo = 360;
    let sqft_Hw = 1680;
    
    //find the sqft int variant metafields
    product.variants.forEach(function(variant){ 
      let sqft = Shopify.productMeta[variant.id]?.sqftPerCarton;
      if(sqft){
        if(variant.option1.includes('Main Beam')){sqft_Mb = sqft}
        if(variant.option1.includes('Molding')){sqft_Mo = sqft}
        if(variant.option1.includes('Cross Tee')){
          if (variant.option2.includes('24')) {sqft_Ct2 = sqft}
          if (variant.option2.includes('48')) {sqft_Ct4 = sqft}
        }
      }
    })
    
    resultsObject = {
        mainBeam: area * 0.25,
        mainBeamCartons: Math.ceil((area * 0.25) / sqft_Mb),
        crossTee4ft: area * 0.5,
        crossTee4ftCartons: Math.ceil((area * 0.5) / sqft_Ct4),
        crossTee2ft: area * 0.25,
        crossTee2ftCartons: Math.ceil((area * 0.25) / sqft_Ct2),
        molding: area * 0.3,
        moldingCartons: Math.ceil((area * 0.3) / sqft_Mo),
        hangerWire: area * 0.16,
        hangerWireCartons: Math.ceil((area * 0.16) / sqft_Hw)
    }
    //set 0 if tile_dimension = 48x24
    const size = tile_dimension.replaceAll('"','').split(' x ').map(i=>$.trim(i));
    if(size.includes('48')){
      resultsObject.crossTee2ftCartons = 0;
    }   
    this.results = resultsObject;
    return resultsObject;
  },
  calculateUpsellFromQuantity: function(quantity){
    var AREA_BUFFER_RATIO = 1.02;    
    let sqftPerCarton = Shopify.productMeta[gvariant.id]?.sqftPerCarton;
    let totalArea = ( quantity * sqftPerCarton);
    // Additional material to cover any breaks or waste
    totalArea = totalArea * AREA_BUFFER_RATIO;
    totalArea = Math.ceil( totalArea);
    // totalArea = roundOffTo(totalArea);// round to next 100
    this.calculateUpsell(totalArea);
  },
  calculateUpsell: function(area){
    const size = $('.swatch:contains("Size") .slVariant').text().split('x').map(i=>$.trim(i));
    this.values.tileDimension = `${size[1]}" x ${size[0]}"`;
    this.values.totalArea = area;
    this.calculateMaterials();
    this.setQtyUpsell();
    CalculateNewTotal(); //update Grid System Total
  },
  setQtyUpsell: function(){
    const results = this.results;
    $( ".grid-system-container.slider-container" ).each(function(index,element) {
      let productName = $(element).find('.grid-system-product-title').text();
      if(typeof productName !== 'string') return;
      productName = productName.toLowerCase().replace(/[\\'"`\s]/g, ''); //Remove double quotes, single quotes, slash and whitespace from the product name.
      const productQty = $(element).find('.qty');
      if(productName.includes("mainbeam")) {
        productQty.val(results.mainBeamCartons);
      } else if(productName.includes('24crosstee')){
        productQty.val(results.crossTee2ftCartons);
      } else if(productName.includes('48crosstee')){
        productQty.val(results.crossTee4ftCartons);
      } else if(productName.includes("molding")){
        productQty.val(results.moldingCartons);
      } else if(productName.includes("hangerwire")){
        productQty.val(results.hangerWireCartons);
      }
    });
  },
  save: function(){
    if(lStorageAvailable){
      localStorage.setItem('estimator_grid', JSON.stringify(this.values));
    }
    // Fran part to modify qtys
    var quantities_to_apply = []
    const results = this.results;
    //apply changes to pdp quantities.
    $( ".variant-accordion-card" ).each(function() {
      const variantid = $(this).attr('id').split("-")[1];
     //match data 
     const productName = $(this).find('.product-title p').text();
    if(productName.includes("Main Beam")) {
      quantities_to_apply.push({'id': variantid,'newQuantity':results.mainBeamCartons});
    } else if(productName.includes('24" Cross Tee')){
      quantities_to_apply.push({'id': variantid,'newQuantity':results.crossTee2ftCartons});
    } else if(productName.includes('48" Cross Tee')){
      quantities_to_apply.push({'id': variantid,'newQuantity':results.crossTee4ftCartons});
    } else if(productName.includes("Molding")){
      quantities_to_apply.push({'id': variantid,'newQuantity':results.moldingCartons});
    } else if(productName.includes("Hanger Wire")){
      quantities_to_apply.push({'id': variantid,'newQuantity':results.hangerWireCartons});
    }
   });
   this.setNewValues(quantities_to_apply);
   // end set quantities
    $('.link-modal-estimator .calculate-text').text('Edit your calculations');

    $('.qty-estimator-results-txt-inner').removeClass('tw-hidden');
    $('#qty-estimator-calculated-area').html(this.values.totalArea.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
    if($('.kanopi-add-to-cart').hasClass('tw-border-t')){
    $('.kanopi-add-to-cart').removeClass('tw-border-t');
    }
    $('#modal-grid-estimator .close-modal-btn').trigger('click');
  },
  setNewValues: function(data){
    data.forEach(element => {
      if (element.newQuantity ) {
        selectVariantCard(element.id);
      } else {
        unselectVariantCard(element.id);
      }
      $('#quantity-'+element.id).val(element.newQuantity);
    });
    if (typeof initQuantityTotal === 'function') initQuantityTotal();
    if (typeof updateTotalPrice === 'function') updateTotalPrice();
  },
  nextStep: function(current,timer=500){
    let self = this;
    this.step = current + 1;
    setTimeout(function () {
      self.step1ValidateButton();
      $('.estimator-steps').hide();
      $('.step'+estimatorGrid.step+'-estimator').show();
      if(estimatorGrid.step == 2){
        $('.estimator-back').css('opacity',1);
      }else{
        $('.estimator-back').css('opacity',0);
      }
    },timer);
  },
  clear: function(){
    $('.option1-step1').removeClass('selected-option');
    $('.option2-step1').removeClass('selected-option');
    $('.option2-step1').find('.form-estimator-selected').hide();
    $('.option1-step1').find('.form-estimator-selected').hide();
    $('step1-estimator-options input').prop( "checked", false );
    $('.continue-button').removeClass('tw-block');
    this.values=JSON.parse(JSON.stringify(this.valuesDefault));
    localStorage.removeItem('estimator_grid');
  },
  refresh: function() {
    this.nextStep(0,0);
    this.values=JSON.parse(JSON.stringify(this.valuesDefault));
    if(lStorageAvailable){
      this.values = JSON.parse( localStorage.getItem('estimator_grid') || JSON.stringify(this.valuesDefault));

      // If the local storage is set with values we need to show the continue button
      // to proceed to the next step with the current selection, otherwise we need to
      // clear the selections to not show anything selected
      if (localStorage.getItem("estimator_grid") !== null) {
        $('.continue-button').addClass('tw-block');
      } else {
        estimatorGrid.clear();
      }
    }
    setTimeout(() => {
      $('.estimation-input-area').val(this.values.iArea);
      $('.estimation-input-width').val(this.values.iWidth);
      $('.estimation-input-length').val(this.values.iLength);
      $('#estimation-type-'+this.values.type).click().change();
      this.step2ValidateButton();
    }, 1000);
  },
  modalStatus : function() {
    if($('#modal-grid-estimator').hasClass('show')) {
      $('.drift-frame-controller').hide();
    } else{
        $('.drift-frame-controller').show();
      } 
  },
  init: function(){
    this.clear();
    this.refresh();
    this.generalActions();
    this.step1ValidateButton();
    this.step1Actions();
    this.step2ACtions();
  }  
};
$( document ).ready(function() {
  estimatorGrid.init();
  if($('#modal-grid-estimator').length>0){
    setInterval(estimatorGrid.modalStatus, 500);
  }
 
});